import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { ACADEMY_LOGO_H } from "../data/assets";

const GOLD = "#D4AF37";

// Shared shell for Terms / Privacy pages.
export default function LegalLayout({ title, updated, intro, sections, testid }) {
  const navigate = useNavigate();
  React.useEffect(() => { window.scrollTo(0, 0); }, [title]);
  return (
    <div data-testid={testid} className="min-h-screen bg-[#0a0a0a] text-white elite-carbon-bg grain">
      <header className="sticky top-0 z-30 bg-[#111]/85 backdrop-blur-xl border-b border-white/10 px-4 sm:px-6 pb-4 header-safe flex items-center justify-between gap-3">
        <button data-testid="legal-back-btn" onClick={() => navigate("/")} className="flex items-center gap-2 text-white/60 hover:text-white text-sm font-bold uppercase tracking-wider py-2 transition-colors"><ArrowLeft size={16} /> Home</button>
        <img src={ACADEMY_LOGO_H} alt="The Next O Technical Academy" className="h-9 w-auto object-contain" />
      </header>
      <main className="max-w-3xl mx-auto px-5 sm:px-8 py-12 sm:py-16">
        <div className="font-mono text-[10px] uppercase tracking-[0.35em] mb-3" style={{ color: GOLD }}>The Next O Technical Academy · Legal</div>
        <h1 className="font-headings text-4xl sm:text-5xl uppercase tracking-wide leading-none">{title}</h1>
        <p className="text-xs text-white/40 mt-3 font-mono uppercase tracking-widest">Last updated {updated}</p>
        <p className="text-base text-white/70 leading-relaxed mt-8">{intro}</p>
        <ol className="mt-10 space-y-9">
          {sections.map(([heading, body], i) => (
            <li key={heading} data-testid={`legal-section-${i + 1}`} className="border-l-2 pl-5" style={{ borderColor: `${GOLD}66` }}>
              <h2 className="font-headings text-xl sm:text-2xl uppercase tracking-wide mb-2"><span className="mr-2" style={{ color: GOLD }}>{String(i + 1).padStart(2, "0")}</span>{heading}</h2>
              {(Array.isArray(body) ? body : [body]).map((p, j) => <p key={j} className="text-sm sm:text-base text-white/65 leading-relaxed mt-2">{p}</p>)}
            </li>
          ))}
        </ol>
        <div className="mt-14 rounded-xl border p-6 text-sm text-white/60" style={{ borderColor: `${GOLD}44`, background: "rgba(212,175,55,0.06)" }}>
          Questions about this document? Email <a className="font-bold hover:underline" style={{ color: GOLD }} href="mailto:info@nextosoccer.com">info@nextosoccer.com</a>. The Next O Technical Academy · Central Illinois, USA.
        </div>
        <div className="mt-8 flex gap-4 text-[11px] font-bold uppercase tracking-wider text-white/40">
          <button data-testid="legal-terms-link" onClick={() => navigate("/terms")} className="hover:text-white">Terms of Service</button>
          <button data-testid="legal-privacy-link" onClick={() => navigate("/privacy")} className="hover:text-white">Privacy Policy</button>
        </div>
      </main>
    </div>
  );
}
